import {getAgeFactor} from "./ageFactor";

export function calculateSeverancePay({ annualSalary, yearsOfService, ageYears, ageMonths }) {

    let errors = false
    let errorMessage = ""
    let weeklyRate = 0
    let adjustedYearsService = 0
    let basicSeverance = 0
    let ageAdjustmentFactor = 0
    let adjustedSeverancePay = 0
    let oneYearMaxSeveranceLimit = 0
    let estimatedTotalSeverancePayFund = 0
    let biweeklySeverancePayment = 0
    let numberWeeksSeverance = 0

    if (annualSalary < 22584) {
        errors = true
        errorMessage = "Annual pay must be equal or greater than Grade 1, Step 1 pay for 2026 ($22584)."
    }

    if (yearsOfService < 1 ) {
        errors = true
        errorMessage = "Years of service must be 1 year or greater"
    }

    if (ageYears < 0) {
        errors = true
        errorMessage = "Age years must be greater than 0"
    }

    if (ageMonths < 0 || ageMonths > 11) {
        errors = true
        errorMessage = "Age months must be from 0 to 11 months"
    }

    // Step 1. Annual Rate of Basic Pay at Separation.
    // [GIVEN]

    // Step 2. Weekly Rate (divide result of step 1 by 2,087 and then multiply by 40)
    weeklyRate = Math.round(annualSalary / 52.175)

    // Step 3. Adjusted years of service
    // 3A.  If less than 10 years, use value
    // 3B.  If greater, (y-10)*2+10
    if (yearsOfService > 10) {
        adjustedYearsService = (yearsOfService - 10) * 2 + 10
    } else {
        adjustedYearsService = yearsOfService
    }

    // Step 4. Basic severance (weekly rate * adjust years)
    basicSeverance = Math.round(weeklyRate * adjustedYearsService)

    // Step 5. If age > 40, lookup age factor table
    if (ageYears < 40) {
        ageAdjustmentFactor = 1
    } else {
        ageAdjustmentFactor = getAgeFactor(ageYears, ageMonths)
    }

    // Step 6. Adjust severance = basic severance * adjust severance
    adjustedSeverancePay = Math.round(basicSeverance * ageAdjustmentFactor)

    // Step 7. maximumSeverance = 52*weekly rate
    oneYearMaxSeveranceLimit = Math.round(52 * weeklyRate)

    // Step 8. total severance fund = min ( adjusted severance, maximum severance)
    estimatedTotalSeverancePayFund = Math.min(adjustedSeverancePay, oneYearMaxSeveranceLimit)

    // Step 9. biweekly severance = weekly rate * 2
    biweeklySeverancePayment = weeklyRate * 2

    // Step 10. weeks severance = total severance fund/ bi weekly severance
    numberWeeksSeverance = Math.round(estimatedTotalSeverancePayFund / biweeklySeverancePayment) * 2

    return {
        errors,
        errorMessage,
        weeklyRate,
        adjustedYearsService,
        basicSeverance,
        ageAdjustmentFactor,
        adjustedSeverancePay,
        oneYearMaxSeveranceLimit,
        estimatedTotalSeverancePayFund,
        biweeklySeverancePayment,
        numberWeeksSeverance
    }

    //
    // // Round to two decimal places for currency
    // return Math.round(totalSeverance * 100) / 100;
}
